import { HierarchyUtils } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getRootMountingRail } from "../functions/MountingRails";
import { MOUNTING_RAIL_NOT_PART_OF_SOLUTION, NO_UPRIGHTS, NOT_A_MOUNTING_RAIL, } from "../constants/errors";
import { MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS } from "../constants/connectorKeys";
import MountingRailComponent from "../components/MountingRailComponent";
import { getUprights } from "./sectionsHelpers";
import { getHostConnectionComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
/**
 * Takes a mounting rail and checks if it's parent is an upright. If it isn't, it room, and thus it is the root
 * mounting rail of a solution
 *
 * @param mountingRail
 */
export const isRootMountingRail = (mountingRail) => {
    if (!mountingRail.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT))
        throw new Error(NOT_A_MOUNTING_RAIL);
    const parent = HierarchyUtils.parent(mountingRail);
    if (!parent)
        return false;
    return !parent.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT);
};
/**
 * Takes a mounting rail and index all mounting rails in that solution
 * and returns it as an object.
 *
 * @param mountingRail
 * @param indexedMountingRails
 */
export const indexMountingRails = (mountingRail, indexedMountingRails = {}) => {
    const nextMountingRail = getNextRightMountingRail(mountingRail);
    const updatedIndexedMountingRail = Object.assign(Object.assign({}, indexedMountingRails), { [Object.keys(indexedMountingRails).length]: mountingRail });
    if (!nextMountingRail)
        return updatedIndexedMountingRail;
    return indexMountingRails(nextMountingRail, updatedIndexedMountingRail);
};
/**
 * Takes a mounting rail as part of a solution, finds the root of the solution,
 * then index the entire solution.
 *
 * @param mountingRail
 */
export const indexMountingRailsInSolution = (mountingRail) => {
    if (!mountingRail.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT))
        throw new Error(NOT_A_MOUNTING_RAIL);
    const rootMountingRail = getRootMountingRail(mountingRail);
    return indexMountingRails(rootMountingRail);
};
/**
 * Takes a mounting rail and gets the mounting rail to the right of it
 *
 * @param mountingRail
 */
const getNextRightMountingRail = (mountingRail) => {
    var _a;
    const host = getHostConnectionComponent(mountingRail, true);
    if (!host)
        return null;
    const rightUpright = (_a = host.connections.find((connection) => MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS.includes(connection.hostConnector.key))) === null || _a === void 0 ? void 0 : _a.guestConnectorEntity;
    if (!rightUpright)
        throw new Error(NO_UPRIGHTS);
    const nextRightMountingRail = HierarchyUtils.children(rightUpright).find((child) => child.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT));
    if (!nextRightMountingRail)
        return null;
    return nextRightMountingRail;
};
/**
 * Takes a mounting rail and return the index of said mounting rail within it's solution
 *
 * @param mountingRail
 */
export const getMountingRailIndexInSolution = (mountingRail) => {
    const indexedSolution = indexMountingRailsInSolution(mountingRail);
    const indexInSolution = Object.values(indexedSolution).findIndex(({ id }) => id === mountingRail.id);
    if (!indexedSolution)
        throw new Error(MOUNTING_RAIL_NOT_PART_OF_SOLUTION);
    return indexInSolution;
};
export const findLastMountingRail = (entity) => {
    if (entity.hasComponent(MountingRailComponent.id)) {
        const { rightUpright } = getUprights(entity);
        if (!rightUpright)
            throw new Error("No right upright.");
        return findLastMountingRail(rightUpright);
    }
    const mountingRailChild = HierarchyUtils.children(entity).find((child) => child.hasComponent(MountingRailComponent.id));
    const parentMount = HierarchyUtils.parent(entity);
    if (parentMount)
        return parentMount;
    if (!mountingRailChild)
        throw new Error("No mounting rail child found.");
    return findLastMountingRail(mountingRailChild);
};
